import { useEffect, useState } from "react";
import TabMenuAdmin from "../TabMenuAdmin/TabMenuAdmin";
import { ProfileUserData } from "./models/adminUsers.model";
import { getAllUsersService } from "./services/adminUser.service";
import TableUsers from "./components/TableUsers";
import FormCreateUser from "./components/FormCreateUser";
import { Dialog } from "primereact/dialog";
import FormEditUser from "./components/FormEditUser";
import { userDataAdapter } from "./adapters/adminUser.adapter";
import FormChangePassword from "./components/FormChangePassword";
import FormLotteryToUser from "./components/FormLotteryToUser";
import TableLotteryToUser from "./components/TableLotteryToUser";
import { getDataUserByIdService } from "../../../Profile/services/profile.service";
import { ApiLotteryData } from "../AdminLottery/model/adminLottery.model";
import { useNavigate } from "react-router-dom";
import ToastBackControl from "../../../../components/Sidebar/ToastBackControl/ToastBackControl";
import { ToastControlBackendModel } from "../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .admin-users-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc !important; /* Fuerza fondo gris ultra claro */
    min-height: 100vh;
    width: 100%;
    color: #1e293b;
  }
`;

function AdminUsers(): JSX.Element {
  const isAdminValue = localStorage.getItem("isAdmin");
  const navigate = useNavigate();
  const [userData, setUserData] = useState<ProfileUserData[]>([]);
  const [dataUser, setDataUser] = useState<ProfileUserData>();
  const [dialogEditUser, setDialogEditUser] = useState<boolean>(false);
  const [dialogChangePasswordUser, setDialogChangePasswordUser] = useState<boolean>(false);
  const [dialogLotteryToUser, setDialogLotteryToUser] = useState<boolean>(false);
  const [dataLotteryForUser, setDataLotteryForUser] = useState<ApiLotteryData[]>([]);

  const [messageBackend, setMessageBackend] = useState<ToastControlBackendModel>({
    severityValue: "info",
    detailValue: "",
    lifeValue: 3000,
    validateShowMessage: false,
  });

  const getAllUsersData = async () => {
    try {
      const response = await getAllUsersService();
      if (response.length > 0) {
        setUserData(userDataAdapter(response));
      }
    } catch (error) {}
  };

  const findLotteryByUser = async (idUser: number) => {
    try {
      const response = await getDataUserByIdService(idUser);
      const { lottery } = response.data;
      if (lottery.length === 0) {
        setDataLotteryForUser([]);
      } else {
        setDataLotteryForUser(lottery);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isAdminValue !== "1") {
      navigate("/");
    }
    getAllUsersData();
  }, []);

  return (
    <div className="admin-users-root-container">
      <style>{viewStyles}</style>

      {messageBackend.validateShowMessage && (
        <ToastBackControl
          validateShowMessage={messageBackend.validateShowMessage}
          detailValue={messageBackend.detailValue}
          lifeValue={messageBackend.lifeValue}
          severityValue={messageBackend.severityValue}
        />
      )}
      
      <TabMenuAdmin />
      
      {/* Contenedor principal adaptado al layout claro */}
      <main className="admin-users-main-content px-3 md:px-5 py-4">
        
        {/* Cabecera de la sección */}
        <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-4">
          <div className="flex align-items-center gap-3">
            <div className="admin-icon-box shadow-1">
              <i className="pi pi-users text-xl"></i>
            </div>
            <div className="flex flex-column justify-content-center">
              {/* Forzamos color oscuro para romper la herencia del modo oscuro */}
              <h1 
                className="text-xl md:text-2xl font-bold m-0 tracking-tight" 
                style={{ color: "#1e293b" }}
              >
                Administración de Usuarios
              </h1>
              <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                Panel de control para la gestión de credenciales, roles y accesos del sistema.
              </p>
            </div>
          </div>
        </div>

        {/* Bloques de Contenido con fondo blanco forzado */}
        <div className="flex flex-column gap-4 w-full">
          
          {/* Bloque 1: Formulario de Registro */}
          <div className="admin-section-card">
            <FormCreateUser
              getAllUsersData={getAllUsersData}
              setMessageBackend={setMessageBackend}
            />
          </div>

          {/* Bloque 2: Listado en Tabla */}
          <div className="admin-section-card">
            <TableUsers
              setDialogChangePasswordUser={setDialogChangePasswordUser}
              userData={userData}
              setDataUser={setDataUser}
              setDialogEditUser={setDialogEditUser}
              setDialogLotteryToUser={setDialogLotteryToUser}
              findLotteryByUser={findLotteryByUser}
            />
          </div>
        </div>

        {/* DIÁLOGOS (MODALES) COMPACTOS Y TOTALMENTE BLANCOS */}
        {dataUser && (
          <>
            {/* Modal: Editar Usuario */}
            <Dialog
              header="Editar Usuario"
              visible={dialogEditUser}
              onHide={() => setDialogEditUser(false)}
              className="w-full max-w-30rem mx-3"
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              draggable={false}
              resizable={false}
              pt={{
                root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb" } },
                header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.5rem" } },
                content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
                closeButtonIcon: { style: { color: "#1f2937" } }
              }}
            >
              <FormEditUser
                dataUser={dataUser}
                getAllUsersData={getAllUsersData}
                setDialogEditUser={setDialogEditUser}
                key="edit-user"
                setMessageBackend={setMessageBackend}
              />
            </Dialog>

            {/* Modal: Cambio de Contraseña */}
            <Dialog
              header={
                <div className="flex flex-column gap-1">
                  <span style={{ fontSize: "1.1rem", fontWeight: 700, color: "#1f2937" }}>
                    Restablecer Contraseña
                  </span>
                  <span style={{ fontSize: "0.85rem", fontWeight: 500, color: "#6b7280" }}>
                    Usuario: {dataUser.name} {dataUser.lastName}
                  </span>
                </div>
              }
              visible={dialogChangePasswordUser}
              onHide={() => setDialogChangePasswordUser(false)}
              className="w-full max-w-28rem mx-3"
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              draggable={false}
              resizable={false}
              pt={{
                root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb" } },
                header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.5rem" } },
                content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
                closeButtonIcon: { style: { color: "#1f2937" } }
              }}
            >
              <FormChangePassword
                dataUser={dataUser}
                getAllUsersData={getAllUsersData}
                setDialogChangePasswordUser={setDialogChangePasswordUser}
                key="change-password-user"
                setMessageBackend={setMessageBackend}
              />
            </Dialog>

            {/* Modal: Gestión de Sorteos */}
            <Dialog
              header={
                <div className="flex flex-column gap-1">
                  <span className="text-xl font-bold text-gray-900" style={{ color: '#1f2937' }}>Sorteos Asociados</span>
                  <span className="text-sm font-medium text-gray-500" style={{ color: '#6b7280' }}>Usuario: {dataUser.name} {dataUser.lastName}</span>
                </div>
              }
              visible={dialogLotteryToUser}
              onHide={() => setDialogLotteryToUser(false)}
              className="w-full max-w-40rem mx-3"
              breakpoints={{ '960px': '85vw', '641px': '100vw' }}
              draggable={false}
              resizable={false}
              pt={{
                root: { style: { backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #e5e7eb", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" } },
                header: { style: { backgroundColor: "#ffffff", borderBottom: "1px solid #e5e7eb", padding: "1.5rem" } },
                content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
                closeButton: { style: { color: "#4b5563" } }
              }}
            >
              <div className="flex flex-column gap-4">
                <FormLotteryToUser
                  getAllUsersData={getAllUsersData}
                  setDialogLotteryToUser={setDialogLotteryToUser}
                  idUser={dataUser.idUser}
                  key="register-lottery"
                  setMessageBackend={setMessageBackend}
                />
                
                <div className="border-top-1 border-200 pt-4">
                  {dataLotteryForUser.length > 0 ? (
                    <>
                      <h4 className="m-0 mb-3 text-xs font-bold text-gray-500 uppercase tracking-wider">
                        Historial de Sorteos
                      </h4>
                      <TableLotteryToUser dataLotteryForUser={dataLotteryForUser} />
                    </>
                  ) : (
                    <div className="text-center p-3 bg-red-50 border-round-lg border-1 border-red-200">
                      <p className="m-0 text-sm font-medium text-red-600">
                        El usuario no cuenta con sorteos asignados en la plataforma.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </Dialog>
          </>
        )}
      </main>
    </div>
  );
}

export default AdminUsers;